import React, { useEffect, useState } from 'react';
import { Skeleton } from 'antd';

const AvatarImage = ({
  src,
  fallbackSrc,
  alt = '',
  size = 48,
  className = '',
  style = {},
  imgClassName = '',
  imgStyle = {},
}) => {
  const [loaded, setLoaded] = useState(false);
  const [failed, setFailed] = useState(false);
  const [currentSrc, setCurrentSrc] = useState(src);

  useEffect(() => {
    setLoaded(false);
    setFailed(false);
    setCurrentSrc(src);
  }, [src]);

  const showImage = Boolean(currentSrc) && !failed;

  const handleLoad = () => {
    setLoaded(true);
  };

  const handleError = () => {
    if (fallbackSrc && currentSrc !== fallbackSrc) {
      setCurrentSrc(fallbackSrc);
      setLoaded(false);
      return;
    }
    setFailed(true);
    setLoaded(true);
  };

  const handleImgRef = (el) => {
    if (el?.complete && el.naturalWidth > 0) {
      setLoaded(true);
    }
  };

  return (
    <div
      className={`relative shrink-0 overflow-hidden ${className}`}
      style={{ width: size, height: size, ...style }}
    >
      {showImage && !loaded && (
        <Skeleton.Avatar
          active
          size={size}
          shape="circle"
          style={{ position: 'absolute', inset: 0 }}
        />
      )}
      {showImage ? (
        <img
          ref={handleImgRef}
          src={currentSrc}
          alt={alt}
          className={`w-full h-full object-cover ${loaded ? 'opacity-100' : 'opacity-0'} ${imgClassName}`}
          style={imgStyle}
          onLoad={handleLoad}
          onError={handleError}
        />
      ) : null}
    </div>
  );
};

export default AvatarImage;
